module.exports = __webpack_public_path__ + "img/edi-4.1161b7cd.png";